import { render, staticRenderFns } from "./returnStore.vue?vue&type=template&id=ec5ecffe&"
import script from "./returnStore.vue?vue&type=script&lang=js&"
export * from "./returnStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports